module.exports = __webpack_public_path__ + "static/media/activity_details_time.7e1c6af2.svg";